module.exports = __webpack_public_path__ + "static/media/don-os-2.2ad0a8ed.jpg";